import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IBasicDetails } from '../../../../interface/interfaces';

interface IInitialState {
    projectNodePersistent: IBasicDetails | null;
}

const initialState: IInitialState = {
    projectNodePersistent: null,
};

const projectNodeSlice = createSlice({
    name: 'projectNode',
    initialState,
    reducers: {
        saveProjectNode: (state: IInitialState, action: PayloadAction<IBasicDetails>) => {
            state.projectNodePersistent = action.payload;
        },

        removeProjectNode: (state: IInitialState) => {
            state.projectNodePersistent = null;
        },
    },
});

export default projectNodeSlice.reducer;
export const { saveProjectNode, removeProjectNode } = projectNodeSlice.actions;
